export const mbCountry = {
  countryBar: {
    previouslyChosen: 'You have previously chosen {{ country }} as your location.<br>What do you want to do?',
    stay: 'Stay on {{ countryAdjective }} site',
    goTo: 'Go to {{ countryAdjective }} site',
    goToAndUpdate: 'Go to {{ countryAdjective }} site and update my location',
    comingFrom: 'Seems like you are coming from {{ country }}!<br>Do you want to visit our website in your country?'
  },
}
